import React from "react";
import { FaBuilding } from "react-icons/fa";
import { TextInput, Checkbox } from "../../atoms";
import ParentFirmPicker from "../ParentFirmPicker";
import usePermission from "../../../Hooks/usePermission";

const FIRM_TYPES = [
  { value: "customer", label: "Müşteri" },
  { value: "dealer", label: "Bayi" },
  { value: "storage", label: "Depo" },
];

/**
 * Firma oluşturma — 1. adım: tip, kurumsal, ad, üst firma (ana firma ya da
 * bayi, #373), sahibi (#275).
 */
export default function FirmInfoStep({ input, errors, onChange }) {
  const { hasPermission } = usePermission();
  // Sihirbazdaki üst firma: bayi seçiliyse dealerFirm, ana firma seçiliyse adı
  const parent = input.dealerFirm?.id
    ? { kind: "dealer", id: input.dealerFirm.id, firmName: input.dealerFirm.firmName, firmType: "dealer" }
    : input.mainFirmName && input.mainFirmName !== "none"
      ? { kind: "main", id: input.mainFirmName, firmName: input.mainFirmName, firmType: input.firmType }
      : null;
  const handleParent = (next) => {
    onChange("mainFirmName", next?.kind === "main" ? next.firmName : "none");
    onChange("dealerFirm", next?.kind === "dealer" ? { id: next.id, firmName: next.firmName } : null);
  };

  return (
    <div className="space-y-6">
      {/* Firma Tipi — customer, dealer, storage */}
      <div className="bg-gray-50 rounded-lg p-4">
        <h3 className="text-base font-SemiBold text-gray-800 mb-4">Firma Tipi</h3>
        <p className="text-sm text-gray-500 mb-3">
          Firma türünü seçin (yalnızca biri işaretlenebilir).
        </p>
        <div className="flex flex-wrap gap-4">
          {FIRM_TYPES.map(({ value, label }) => (
            <label key={value} className="inline-flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="firmType"
                value={value}
                checked={input.firmType === value}
                onChange={() => onChange("firmType", value)}
                className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
              />
              <span className="text-sm font-Medium text-gray-700">{label}</span>
            </label>
          ))}
        </div>

        <div className="mt-4 pt-3 border-t border-gray-200">
          <Checkbox
            label="Kurumsal Firma"
            checked={input.isCorporate}
            onChange={(e) => onChange("isCorporate", e.target.checked)}
          />
        </div>
      </div>

      {/* Temel Bilgiler */}
      <div className="bg-gray-50 rounded-lg p-4">
        <h3 className="text-base font-SemiBold text-gray-800 mb-4 flex items-center gap-2">
          <FaBuilding className="w-4 h-4 text-blue-600" />
          Temel Bilgiler
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <TextInput
            label="Firma Adı"
            placeholder="Firma adını giriniz"
            value={input.firmName}
            onChange={(e) => onChange("firmName", e.target.value)}
            error={!!errors.firmName}
            errorMessage={errors.firmName}
            required
          />

          {input.firmType === "storage" ? (
            <div className="space-y-1">
              <label className="block text-sm font-Medium text-gray-700">Ana Firma</label>
              <p className="text-sm text-gray-600 bg-indigo-50 border border-indigo-100 rounded-lg px-3 py-2">
                Depo firması için ana firma otomatik olarak <strong>Bayıner</strong> atanır.
              </p>
            </div>
          ) : (
            <ParentFirmPicker
              key={input.firmType}
              label={input.firmType === "dealer" ? "Üst Firma (Ana Bayi)" : "Üst Firma (Ana Firma ya da Bayi)"}
              firmType={input.firmType}
              value={parent}
              onChange={handleParent}
              allowDealer={input.firmType === "customer" && hasPermission("firms.editDealerRelation")}
            />
          )}

          {/* Firma sahibi — ad soyad, isteğe bağlı (#243) */}
          <TextInput
            label="Firma Sahibi (isteğe bağlı)"
            placeholder="Ad Soyad"
            value={input.ownerName}
            onChange={(e) => onChange("ownerName", e.target.value.slice(0, 100))}
            maxLength={100}
          />
        </div>
      </div>
    </div>
  );
}
